export default "__VITE_ASSET__GtC1NiA9__"